import { ApplicationFormValues } from '../../../../../LoanDetailTypes';
import { Ruleset } from '../../../interfaces/Ruleset';
import { RulesetResult, IsPropertyLeased } from '../../rules';
import IsPropertyLandlord from '../../rules/IsPropertyLandlord';

export class SystemPropertyRecordTypeRuleset implements Ruleset {
  private index: number;

  public setIndex(index: number): SystemPropertyRecordTypeRuleset {
    this.index = index;
    return this;
  }

  public evaluate(data: Partial<ApplicationFormValues>): RulesetResult {
    const isLandlord = IsPropertyLandlord.setIndex(this.index).evaluate(data);
    const isLeased = IsPropertyLeased.evaluate(data);
    return isLeased && isLandlord
      ? RulesetResult.REQUIRED
      : RulesetResult.HIDDEN;
  }
}

export default new SystemPropertyRecordTypeRuleset();
